(function () {
  if (window.__lcWishlistBound) return;
  window.__lcWishlistBound = true;

  var STORAGE_KEY = 'lc_wishlist_handles';
  var WISHLIST_URL = '/pages/wishlist';
  var toastTimer;

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('lc:wishlist-updated'));
  }

  function syncWishlistButtons() {
    var list = readWishlist();
    document.querySelectorAll('[data-lc-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      var title = btn.getAttribute('data-product-title') || 'product';
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        active ? 'Remove ' + title + ' from wishlist' : 'Add ' + title + ' to wishlist'
      );
    });
  }

  function ensureToastHost() {
    var host = document.getElementById('lc-wishlist-toast-host');
    if (host) return host;
    host = document.createElement('div');
    host.id = 'lc-wishlist-toast-host';
    host.className = 'lc-wishlist-toast-host';
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }

  function showAddedToast(title) {
    var host = ensureToastHost();
    var safeTitle = title || 'Product';
    host.innerHTML =
      '<div class="lc-wishlist-toast" role="status">' +
      '<span class="lc-wishlist-toast__icon" aria-hidden="true">♥</span>' +
      '<span class="lc-wishlist-toast__text"><strong>Saved to wishlist</strong><span>' +
      escapeHtml(safeTitle) +
      '</span></span>' +
      '<a class="lc-wishlist-toast__link" href="' +
      WISHLIST_URL +
      '">View</a>' +
      '</div>';
    host.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      host.classList.remove('is-visible');
    }, 4200);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-lc-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    var title = btn.getAttribute('data-product-title') || '';
    var list = readWishlist();
    var index = list.indexOf(handle);
    var added = index === -1;

    if (added) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }

    writeWishlist(list);
    syncWishlistButtons();

    if (added) {
      showAddedToast(title);
    }
  });

  window.lcWishlist = {
    addHandle: function (handle) {
      if (!handle) return false;
      var list = readWishlist();
      if (list.indexOf(handle) === -1) {
        list.push(handle);
        writeWishlist(list);
      }
      syncWishlistButtons();
      return true;
    },
    read: readWishlist,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWishlistButtons);
  } else {
    syncWishlistButtons();
  }
  document.addEventListener('shopify:section:load', syncWishlistButtons);
  document.addEventListener('lc:wishlist-updated', syncWishlistButtons);
})();
